import { useQuery } from "react-query"
import { getManHoursProjectsData } from "./manHoursReportApi"

export const useGetManHoursProjectsDataQuery = (startDate?: string, endDate?: string) => {
  return useQuery(['manHoursProjects', startDate, endDate], {
    queryFn: () => getManHoursProjectsData(startDate, endDate),
    refetchOnWindowFocus: false
  })
}